import Constant from '../../const';
const axios = require('axios');

const getPatientQueue = async ({ payload }) => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/queue'),
      payload,
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getPatientQueue;
